/**
 * 新增时间：2026-06-05  新增人：lc  新增目的：生产环境打包配置（dzyys.chinanutri.cn），由 npm run build:prod 通过 vue.config.js 自动加载
 */

const env = process.env.NODE_ENV;

const dev_hostnameport = "https://dzyys.chinanutri.cn";
// 修改时间：2026-06-13  修改人：lc  修改内容：正式站点由 WAF 在默认 HTTPS 端口代理 API，8443 不支持浏览器 HTTPS 握手
const build_hostnameport = "https://dzyys.chinanutri.cn";

const Setting = {
  tenantCode: "yyc",
  isDemo: env === "development" ? false : true,
  titleSuffix: env === "development" ? "电子营养师开发环境" : "电子营养师",
  routerMode: "history",
  routerBase: "/",
  cookiesExpires: 1,

  tenantCenterBaseURL:
    env === "development"
      ? `${dev_hostnameport}/`
      : `${build_hostnameport}/`,

  // 生产环境通过 Host 解析租户，tenantMode: 1
  tenantMode: env === "development" ? 0 : 1,

  apiBaseURL:
    env === "development"
      ? `${dev_hostnameport}/` + "${tenant}"
      : `${build_hostnameport}`,

  xApiBaseURL:
    env === "development" ? `${dev_hostnameport}/` : `${build_hostnameport}`,

  avatarURL:
    env === "development"
      ? `${dev_hostnameport}/upload/avatar/`
      : `${build_hostnameport}/upload/avatar/`,

  attachmentBusinessURL:
    env === "development"
      ? `${dev_hostnameport}/Upload/Picture/`
      : `${build_hostnameport}/Upload/Picture/`,

  yulanPicture:
    env === "development" ? `${dev_hostnameport}` : `${build_hostnameport}`,

  excTemplateURL:
    env === "development"
      ? `${dev_hostnameport}/base/file/Template/ExcelTemplate/`
      : `${build_hostnameport}/base/file/Template/ExcelTemplate/`,

  docTemplateURL:
    env === "development"
      ? `${dev_hostnameport}/base/file/Template/WordTemplate/`
      : `${build_hostnameport}/base/file/Template/WordTemplate/`,

  registerURL:
    env === "development"
      ? `${dev_hostnameport}/base/file/Template/WordTemplate/`
      : `${build_hostnameport}/base/file/Template/WordTemplate/`,

  wordReportURL:
    env === "development"
      ? `${dev_hostnameport}/base/file/upload/word/`
      : `${build_hostnameport}/base/file/upload/word/`,

  baseURL:
    env === "development"
      ? `${dev_hostnameport}/base/file/`
      : `${build_hostnameport}/base/file/`,

  PublicFileURL:
    env === "development"
      ? `${dev_hostnameport}/PublicFile/`
      : `${build_hostnameport}/PublicFile/`,

  layout: {
    tabType: "",
    tabPosition: "top",
    showReload: true,
    showFullscreen: true,
    showNotice: true,
    showI18n: true,
    logoutConfirm: false,
    showBreadcrumbIcon: false,
    showTabIcon: true
  },
  sameRouteForceUpdate: false,
  lstTime: 0,
  lstRefrash: { reqState: 0, clickTime: 0 },
  lstRefrashTim: 0,
  loopConfig: { reqState: 0, setTimNum: 0, loopTime: 120000 },
  RefrashState: 0
};

export default Setting;
